import moment from "moment";
import React from "react";
import { toast } from "react-semantic-toasts";
import {
  Button,
  Checkbox,
  Container,
  Dropdown,
  Form,
  Grid,
  Icon,
  Label,
  Modal,
  Popup,
  Rating,
  Segment,
  Table
} from "semantic-ui-react";
import cv_registryFormData from "../../../assets/resources/cv_registryFormData";
import ProjectForm from "../../../components/core/project/ProjectForm";
import PaginatedReusableTable from "../../../components/shared/PaginatedReusableTable";
import constants from "../../../utils/constants";
import ExperienceTabPanel from "./ExperienceTabPanel";
import SkillsTabPanel from "./SkillsTabPanel";
import "./CvGeneratorComponent.css";

const monthStr = [
  {
    key: "01",
    text: "January",
    value: "January",
  },
  {
    key: "02",
    text: "February",
    value: "February",
  },
  {
    key: "03",
    text: "March",
    value: "March",
  },
  {
    key: "04",
    text: "April",
    value: "April",
  },
  {
    key: "05",
    text: "May",
    value: "May",
  },
  {
    key: "06",
    text: "June",
    value: "June",
  },
  {
    key: "07",
    text: "July",
    value: "July",
  },
  {
    key: "08",
    text: "August",
    value: "August",
  },
  {
    key: "09",
    text: "September",
    value: "September",
  },
  {
    key: "10",
    text: "October",
    value: "October",
  },
  {
    key: "11",
    text: "November",
    value: "November",
  },
  {
    key: "12",
    text: "December",
    value: "December",
  },
];

const columns_technical_skills = [
  {
    Header: "Name",
    accessor: "technical_skill",
    id: "technical_skill",
  },
  {
    Header: "Level",
    accessor: "level",
    id: "level",
  },
];

const columns_soft_skills = [
  {
    Header: "Name",
    accessor: "soft_skill",
    id: "soft_skill",
  },
  {
    Header: "Level",
    accessor: "level",
    id: "level",
  },
];

const columns_languages = [
  {
    Header: "Name",
    accessor: "language",
    id: "language",
  },
  {
    Header: "Level",
    accessor: "level",
    id: "level",
  },
];

const minLevel = 1;
const maxLevel = 5;

class CvGeneratorComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: -1,
      openWorkModal: false,
      openEducationModal: false,
      openCertificationModal: false,
      startDate: moment().startOf("year"),
      endDate: moment(),
      openLevelTechnicalSkillModal: false,
      openLevelSoftSkillModal: false,
      openLevelLanguageModal: false,
      name: "",
      defaultLevel: 3,
      pictures: [],
      exampleData: [{ key: "value" }],
      userId: "",
      editable: false,
      workExperience: {
        start: moment(),
        end: moment(),
        startYear: moment().year(),
        startMonth: moment().format("MMMM"),
        endYear: moment().year(),
        endMonth: moment().format("MMMM"),
        // ADA-131: "role" fields below refer to Business Title in the UI
        role: "",
        role_id: null,
        project_title: "",
        customer: "",
        sector: "",
        customer_id: null,
        is_external: 0,
        sector_id: null,
        description: "",
        customer_flag: false,
        role_flag: false,
        sector_flag: false,
        title_flag: false,
        description_flag: false,

        is_active: 0,
        visible_on_cv: 1,
      },

      workExperienceKey: "",
      education: {
        start: moment(),
        end: moment(),
        startYear: moment().year(),
        startMonth: moment().format("MMMM"),
        endYear: moment().year(),
        endMonth: moment().format("MMMM"),
        university: "",
        degree: "",
        discipline: "",
        university_id: 0,
        degree_id: 0,
        discipline_id: 0,
        vote: "",
        university_flag: false,
        discipline_flag: false,
      },
      educationId: "",
      degreeSelected: false,
      certification: {
        start: moment(),
        end: moment(),
        startYear: moment().year(),
        startMonth: moment().format("MMMM"),
        type_of_certification: "",
        name: "",
      },
      certificationId: "",
      certification_flag: false,
      levelTechnicalSkill: {
        level: 1,
      },
      technicalSkillId: 0,
      levelSoftSkill: {
        level: 1,
      },
      softSkillId: 0,
      levelLanguage: {
        level: 1,
      },
      languageId: 0,
      curriculumVitaeId: "",
      checked: false,
      checkValue: true,
      categoryId: "",
      selectedCategory: false,
      selectedDiscipline: false,
      selectedUniversity: false,
      // ADA-131: "role" fields below refer to Business Title in the UI
      openModalRole: false,
      roleId: 0,
      roleName: "No Role",
      is_sysadmin: 0,
      openControlModalWorkExperience: false
    };

    this.onDrop = this.onDrop.bind(this);
  }

  onDrop(picture) {
    let filename = this.props.auth.user.attributes.email;

    this.setState({
      pictures: this.state.pictures.concat(picture),
    });

    this.props.uploadImageCV(picture, filename, this.props.auth.unique_id);
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  };

  handleChange = (e, data) => {
    this.setState((prevState) => ({
      values: {
        ...prevState.values,
        [data.name]: data.value,
      },
    }));
  };

  openWorkModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      openWorkModal: true,
    }));
  };

  openEditWorkModal = (e, data) => {
    let index = data.dataindex;

    this.setState((prevState) => ({
      ...prevState,
      openWorkModal: true,
      editable: true,
      workExperience: {
        customer: this.props.userWorkExperienceRaw[index - 1].customer,
        customer_id: this.props.userWorkExperienceRaw[index - 1].customer_id,
        customer_flag: true,
        is_external: this.props.userWorkExperienceRaw[index - 1].is_external,
        description: this.props.userWorkExperienceRaw[index - 1].description,
        end: this.props.userWorkExperienceRaw[index - 1].end,
        id: this.props.userWorkExperienceRaw[index - 1].id,
        is_active: this.props.userWorkExperienceRaw[index - 1].is_active,
        visible_on_cv: this.props.userWorkExperienceRaw[index - 1].visible_on_cv,
        project_title: this.props.userWorkExperienceRaw[index - 1]
          .project_title,
        title_flag: (this.props.userWorkExperienceRaw[index - 1].project_title === null) ? false : true,
        description_flag: (this.props.userWorkExperienceRaw[index - 1].description === null) ? false : true,
        role: this.props.userWorkExperienceRaw[index - 1].role,
        role_id: this.props.userWorkExperienceRaw[index - 1].role_id,
        role_flag: true,
        sector: this.props.userWorkExperienceRaw[index - 1].sector,
        sector_id: this.props.userWorkExperienceRaw[index - 1].sector_id,
        sector_flag: true,
        start: this.props.userWorkExperienceRaw[index - 1].start,
        endMonth: moment(
          this.props.userWorkExperienceRaw[index - 1].end.substring(5, 7)
        ).format("MMMM"),
        startMonth: moment(
          this.props.userWorkExperienceRaw[index - 1].start.substring(5, 7)
        ).format("MMMM"),
        endYear: parseInt(
          this.props.userWorkExperienceRaw[index - 1].end.substring(0, 4)
        ),
        startYear: parseInt(
          this.props.userWorkExperienceRaw[index - 1].start.substring(0, 4)
        ),
      },
      workExperienceKey: this.props.userWorkExperienceOptions[index - 1].key,
    }));
  };

  closeWorkModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      openWorkModal: false,
      editable: false,
      workExperience: {
        start: moment(),
        end: moment(),
        startYear: moment().year(),
        startMonth: moment().format("MMMM"),
        endYear: moment().year(),
        endMonth: moment().format("MMMM"),
        role: "",
        role_id: null,
        project_title: "",
        customer: "",
        is_external: 0,
        sector: "",
        customer_id: null,
        sector_id: null,
        description: "",
        is_active: 0,
        visible_on_cv: 1
      },
      workExperienceKey: "",
    }));
  };

  openEducationModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      openEducationModal: true,
    }));
  };

  openEditEducationModal = (e, data) => {
    let index = data.dataindex;

    this.props.getDiscipline(
      this.props.language,
      this.props.userEducationRaw[index - 1].degree_id
    );
    this.props.getUniversity(
      this.props.language,
      this.props.userEducationRaw[index - 1].degree_id
    );

    this.setState((prevState) => ({
      ...prevState,
      openEducationModal: true,
      editable: true,
      educationId: this.props.userEducationOptions[index - 1].key,
      education: {
        ...prevState.education,

        degree: this.props.userEducationRaw[index - 1].degree,
        degree_id: this.props.userEducationRaw[index - 1].degree_id,
        discipline: this.props.userEducationRaw[index - 1].discipline,
        discipline_id: this.props.userEducationRaw[index - 1].discipline_id,
        end: this.props.userEducationRaw[index - 1].end,
        id: this.props.userEducationRaw[index - 1].id,
        start: this.props.userEducationRaw[index - 1].start,
        university: this.props.userEducationRaw[index - 1].university,
        university_id: this.props.userEducationRaw[index - 1].university_id,
        vote: this.props.userEducationRaw[index - 1].vote,
        endMonth: moment(
          this.props.userEducationRaw[index - 1].end.substring(5, 7)
        ).format("MMMM"),
        startMonth: moment(
          this.props.userEducationRaw[index - 1].start.substring(5, 7)
        ).format("MMMM"),
        endYear: parseInt(
          this.props.userEducationRaw[index - 1].end.substring(0, 4)
        ),
        startYear: parseInt(
          this.props.userEducationRaw[index - 1].start.substring(0, 4)
        ),
        university_flag: true,
        discipline_flag: true,
      },
      degreeSelected: true,
    }));
  };

  closeEducationModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      openEducationModal: false,
      editable: false,
      education: {
        start: moment(),
        end: moment(),
        startYear: moment().year(),
        startMonth: moment().format("MMMM"),
        endYear: moment().year(),
        endMonth: moment().format("MMMM"),
        university: "",
        degree: "",
        discipline: "",
        university_id: null,
        degree_id: null,
        discipline_id: null,
        vote: "",
      },
      educationId: "",
      degreeSelected: false,
    }));
  };

  openCertificationModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      openCertificationModal: true,
    }));
  };

  openEditCertificationModal = (e, data) => {
    let index = data.dataindex;

    this.setState((prevState) => ({
      ...prevState,
      openCertificationModal: true,
      editable: true,

      certification: {
        end: this.props.userCertificationsRaw[index - 1].end,
        id: this.props.userCertificationsRaw[index - 1].id,
        name: this.props.userCertificationsRaw[index - 1].name,
        start: this.props.userCertificationsRaw[index - 1].start,
        type_of_certification: this.props.userCertificationsRaw[index - 1]
          .type_of_certification,
        startMonth: moment(
          this.props.userCertificationsRaw[index - 1].start.substring(5, 7)
        ).format("MMMM"),
        startYear: parseInt(
          this.props.userCertificationsRaw[index - 1].start.substring(0, 4)
        ),
      },
      certificationId: this.props.userCertificationOptions[index - 1].key,
      certification_flag: true,
    }));
  };

  closeCertificationModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      openCertificationModal: false,
      editable: false,
      certification: {
        start: moment(),
        end: moment(),
        startYear: moment().year(),
        startMonth: moment().format("MMMM"),
        type_of_certification: "",
        name: "",
      },
      certificationId: "",
    }));
  };

  openLevelTechnicalSkillModal = (e, data) => {
    this.setState((prevState) => ({
      ...prevState,
      openLevelTechnicalSkillModal: true,
      editable: true,
    }));
  };

  closeLevelTechnicalSkillModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      openLevelTechnicalSkillModal: false,
      editable: false,
      technicalSkillId: 0,
      name: "",
    }));
    return null;
  };

  openLevelSoftSkillModal = (e, data) => {

    this.setState((prevState) => ({
      ...prevState,
      openLevelSoftSkillModal: true,
      editable: true,
    }));
  };

  closeLevelSoftSkillModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      openLevelSoftSkillModal: false,
      editable: false,
      softSkillId: 0,
      name: "",
    }));

    return null;
  };

  openLevelLanguageModal = (e, data) => {
    this.setState((prevState) => ({
      ...prevState,
      openLevelLanguageModal: true,
      editable: true,
    }));
  };

  openLevelLanguageModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      openLevelLanguageModal: false,
      editable: false,
    }));
  };

  closeLevelLanguageModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      openLevelLanguageModal: false,
      editable: false,
      languageId: 0,
      name: "",
    }));
  };

  // --- ExperienceTabPanel callbacks ---

  handleEditWorkByIndex = (index) => {
    this.openEditWorkModal(null, { dataindex: index + 1 })
  };

  handleEditEducationByIndex = (index) => {
    this.openEditEducationModal(null, { dataindex: index + 1 })
  };

  handleEditCertificationByIndex = (index) => {
    this.openEditCertificationModal(null, { dataindex: index + 1 })
  };

  // --- SkillsTabPanel callbacks ---

  handleAddTechnicalSkill = (skillId, level) => {
    const onFailure = (res) => {
      let description = "";
      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error adding. Try Again";
      else description = "You cannot perform this action.";
      toast({ title: "Technical Skill", description: description, type: "error", icon: "file", time: constants.TOAST_ERROR_TIMEOUT, animation: "fly left" });
    };
    const onSuccess = () => {
      toast({ title: "Technical Skill", description: "Added successfully.", type: "success", icon: "check", time: constants.TOAST_SUCCESS_TIMEOUT, animation: "fly left" });
    };
    this.props.createUserTechnicalSkill(skillId, this.props.userRegistryRaw[0].curriculum_vitae_id, { level: level }, this.props.auth.unique_id, this.props.language, onSuccess, onFailure);
  };

  handleEditTechnicalSkill = (skillId, newLevel) => {
    const onFailure = (res) => {
      let description = "";
      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error editing. Try Again";
      else description = "You cannot perform this action.";
      toast({ title: "Technical Skill", description: description, type: "error", icon: "file", time: constants.TOAST_ERROR_TIMEOUT, animation: "fly left" });
    };
    const onSuccess = () => {
      toast({ title: "Technical Skill", description: "Edited successfully.", type: "success", icon: "check", time: constants.TOAST_SUCCESS_TIMEOUT, animation: "fly left" });
    };
    this.props.editUserTechnicalSkill(skillId, this.props.userRegistryRaw[0].curriculum_vitae_id, { level: newLevel }, this.props.auth.unique_id, this.props.language, onSuccess, onFailure);
  };

  handleDeleteTechnicalSkill = (skillId) => {
    const onFailure = (res) => {
      let description = "";
      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error deleting. Try Again";
      else description = "You cannot perform this action.";
      toast({ title: "Technical Skill", description: description, type: "error", icon: "file", time: constants.TOAST_ERROR_TIMEOUT, animation: "fly left" });
    };
    const onSuccess = () => {
      toast({ title: "Technical Skill", description: "Deleted successfully.", type: "success", icon: "check", time: constants.TOAST_SUCCESS_TIMEOUT, animation: "fly left" });
    };
    this.props.deleteUserTechnicalSkill(skillId, this.props.userRegistryRaw[0].curriculum_vitae_id, this.props.auth.unique_id, this.props.language, onSuccess, onFailure);
  };

  handleAddSoftSkill = (skillId, level) => {
    const onFailure = (res) => {
      let description = "";
      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error adding. Try Again";
      else description = "You cannot perform this action.";
      toast({ title: "Soft Skill", description: description, type: "error", icon: "file", time: constants.TOAST_ERROR_TIMEOUT, animation: "fly left" });
    };
    const onSuccess = () => {
      toast({ title: "Soft Skill", description: "Added successfully.", type: "success", icon: "check", time: constants.TOAST_SUCCESS_TIMEOUT, animation: "fly left" });
    };
    this.props.createUserSoftSkill(skillId, this.props.userRegistryRaw[0].curriculum_vitae_id, { level: level }, this.props.auth.unique_id, this.props.language, onSuccess, onFailure);
  };

  handleEditSoftSkill = (skillId, newLevel) => {
    const onFailure = (res) => {
      let description = "";
      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error editing. Try Again";
      else description = "You cannot perform this action.";
      toast({ title: "Soft Skill", description: description, type: "error", icon: "file", time: constants.TOAST_ERROR_TIMEOUT, animation: "fly left" });
    };
    const onSuccess = () => {
      toast({ title: "Soft Skill", description: "Edited successfully.", type: "success", icon: "check", time: constants.TOAST_SUCCESS_TIMEOUT, animation: "fly left" });
    };
    this.props.editUserSoftSkill(skillId, this.props.userRegistryRaw[0].curriculum_vitae_id, { level: newLevel }, this.props.auth.unique_id, this.props.language, onSuccess, onFailure);
  };

  handleDeleteSoftSkill = (skillId) => {
    const onFailure = (res) => {
      let description = "";
      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error deleting. Try Again";
      else description = "You cannot perform this action.";
      toast({ title: "Soft Skill", description: description, type: "error", icon: "file", time: constants.TOAST_ERROR_TIMEOUT, animation: "fly left" });
    };
    const onSuccess = () => {
      toast({ title: "Soft Skill", description: "Deleted successfully.", type: "success", icon: "check", time: constants.TOAST_SUCCESS_TIMEOUT, animation: "fly left" });
    };
    this.props.deleteUserSoftSkill(skillId, this.props.userRegistryRaw[0].curriculum_vitae_id, this.props.auth.unique_id, this.props.language, onSuccess, onFailure);
  };

  handleAddLanguage = (languageId, level) => {
    const onFailure = (res) => {
      let description = "";
      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error adding. Try Again";
      else description = "You cannot perform this action.";
      toast({ title: "Language", description: description, type: "error", icon: "file", time: constants.TOAST_ERROR_TIMEOUT, animation: "fly left" });
    };
    const onSuccess = () => {
      toast({ title: "Language", description: "Added successfully.", type: "success", icon: "check", time: constants.TOAST_SUCCESS_TIMEOUT, animation: "fly left" });
    };
    this.props.createUserLanguage(languageId, this.props.userRegistryRaw[0].curriculum_vitae_id, { level: level }, this.props.auth.unique_id, this.props.language, onSuccess, onFailure);
  };

  handleEditLanguage = (languageId, newLevel) => {
    const onFailure = (res) => {
      let description = "";
      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error editing. Try Again";
      else description = "You cannot perform this action.";
      toast({ title: "Language", description: description, type: "error", icon: "file", time: constants.TOAST_ERROR_TIMEOUT, animation: "fly left" });
    };
    const onSuccess = () => {
      toast({ title: "Language", description: "Edited successfully.", type: "success", icon: "check", time: constants.TOAST_SUCCESS_TIMEOUT, animation: "fly left" });
    };
    this.props.editUserLanguage(languageId, this.props.userRegistryRaw[0].curriculum_vitae_id, { level: newLevel }, this.props.auth.unique_id, this.props.language, onSuccess, onFailure);
  };

  handleDeleteLanguage = (languageId) => {
    const onFailure = (res) => {
      let description = "";
      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error deleting. Try Again";
      else description = "You cannot perform this action.";
      toast({ title: "Language", description: description, type: "error", icon: "file", time: constants.TOAST_ERROR_TIMEOUT, animation: "fly left" });
    };
    const onSuccess = () => {
      toast({ title: "Language", description: "Deleted successfully.", type: "success", icon: "check", time: constants.TOAST_SUCCESS_TIMEOUT, animation: "fly left" });
    };
    this.props.deleteUserLanguage(languageId, this.props.userRegistryRaw[0].curriculum_vitae_id, this.props.auth.unique_id, this.props.language, onSuccess, onFailure);
  };

  // --- End SkillsTabPanel callbacks ---

  openModalRole = () => {
    this.props.roleOptions.map((opt) => {
      if (opt.value === this.props.userRegistryRaw[0].business_title) {
        this.setState((prevState) => ({
          ...prevState,
          roleId: opt.key,
        }));
      }
      return null;
    });

    this.setState((prevState) => ({
      ...prevState,
      openModalRole: true,
      roleName: this.props.userRegistryOption[0].business_title
        ? this.props.userRegistryOption[0].business_title.split(" -")[0]
        : null,
    }));
  };

  closeModalRole = () => {
    this.setState((prevState) => ({
      ...prevState,
      openModalRole: false,
    }));
  };

  onSelectRowTechnicalSkill = (selectedRow) => {
    let id = selectedRow.id;
    let skill = selectedRow.technical_skill;
    let lev = selectedRow.level;

    this.setState((prevState) => ({
      ...prevState,
      openLevelTechnicalSkillModal: true,
      name: skill,
      technicalSkillId: id,
      levelTechnicalSkill: {
        level: lev,
      },
      editable: true,
    }));
  };

  onSelectTechnicalSkill = (e, data) => {
    let id = 0;
    const name = data.value;
    let lev = 1;

    data.options.map((opt) => {
      if (opt.value === name) {
        id = opt.key;
      }
      return null;
    });

    this.setState((prevState) => ({
      ...prevState,
      openLevelTechnicalSkillModal: true,
      name: name,
      technicalSkillId: id,
      levelTechnicalSkill: {
        level: lev,
      },
    }));
  };

  onSelectSoftSkill = (e, data) => {
    let id = 0;
    const name = data.value;
    let lev = 1;

    data.options.map((opt) => {
      if (opt.value === name) {
        id = opt.key;
      }
      return null;
    });

    this.setState((prevState) => ({
      ...prevState,
      openLevelSoftSkillModal: true,
      name: name,
      softSkillId: id,
      levelSoftSkill: {
        level: lev,
      },
    }));
  };

  onSelectLanguage = (e, data) => {
    let id = 0;
    const name = data.value;
    let lev = 1;

    data.options.map((opt) => {
      if (opt.value === name) {
        id = opt.key;
      }
      return null;
    });

    this.setState((prevState) => ({
      ...prevState,
      openLevelLanguageModal: true,
      name: name,
      languageId: id,
      levelLanguage: {
        level: lev,
      },
    }));
  };

  onSelectRowSoftSkill = (selectedRow) => {
    this.setState((prevState) => ({
      ...prevState,
      openLevelSoftSkillModal: true,
      name: selectedRow.soft_skill,
      softSkillId: selectedRow.id,
      levelSoftSkill: {
        level: selectedRow.level,
      },
      editable: true,
    }));
  };
  onSelectRowLanguage = (selectedRow) => {
    this.setState((prevState) => ({
      ...prevState,
      openLevelLanguageModal: true,
      name: selectedRow.language,
      languageId: selectedRow.id,
      levelLanguage: {
        level: selectedRow.level,
      },
      editable: true,
    }));
  };

  handleChangeValueWorkExperience = (e, { name, value }) => {
    if (name === "sector") {
      if (value === "") {
        this.setState((prevState) => ({
          ...prevState,
          workExperience: {
            ...prevState.workExperience,
            sector_flag: false
          },
        }));
      }
      this.props.sectorOptions.map((opt) => {
        if (opt.value === value) {
          this.setState((prevState) => ({
            ...prevState,
            workExperience: {
              ...prevState.workExperience,
              sector_id: opt.key,
              sector: opt.value,
              sector_flag: true
            },
          }));
        }
        return null;
      });
    } else if (name === "role") {
      if (value === "") {
        this.setState((prevState) => ({
          ...prevState,
          workExperience: {
            ...prevState.workExperience,
            role_flag: false
          },
        }));
      }
      this.props.roleOptions.map((opt) => {
        if (opt.value === value) {
          this.setState((prevState) => ({
            ...prevState,
            workExperience: {
              ...prevState.workExperience,
              role_id: opt.key,
              role: opt.value,
              role_flag: true,
            },
          }));
        }
        return null;
      });
    } else if (name === "customer") {
      if (value === "") {
        this.setState((prevState) => ({
          ...prevState,
          workExperience: {
            ...prevState.workExperience,
            customer_flag: false
          },
        }));
      }
      this.props.customerOptions.map((opt) => {
        if (opt.value === value) {
          this.setState((prevState) => ({
            ...prevState,
            workExperience: {
              ...prevState.workExperience,
              customer_id: opt.key,
              customer: opt.value,
              is_external: opt.is_external,
              customer_flag: true
            },
          }));
        }
        return null;
      });
    } else if (name === "project_title") {
      if (value === "") {
        this.setState((prevState) => ({
          ...prevState,
          workExperience: {
            ...prevState.workExperience,
            title_flag: false
          },
        }));
      } else {
        this.setState((prevState) => ({
          ...prevState,
          workExperience: {
            ...prevState.workExperience,
            title_flag: true
          },
        }));
      }
      this.setState((prevState) => ({
        ...prevState,
        workExperience: {
          ...prevState.workExperience,
          [name]: value,
        },
      }));
    } else if (name === "description") {
      if (value === "") {
        this.setState((prevState) => ({
          ...prevState,
          workExperience: {
            ...prevState.workExperience,
            description_flag: false
          },
        }));
      } else {
        this.setState((prevState) => ({
          ...prevState,
          workExperience: {
            ...prevState.workExperience,
            description_flag: true
          },
        }));
      }
      this.setState((prevState) => ({
        ...prevState,
        workExperience: {
          ...prevState.workExperience,
          [name]: value,
        },
      }));
    } else {
      this.setState((prevState) => ({
        ...prevState,
        workExperience: {
          ...prevState.workExperience,
          [name]: value,
        },
      }));
    }
  };

  handleChangeValueEducation = (e, { name, value }) => {
    if (name === "university") {
      if (value === "") {
        this.setState((prevState) => ({
          ...prevState,
          education: {
            ...prevState.education,
            university_flag: false
          },
        }));
      }
      this.props.universityOptions.map((opt) => {
        if (opt.value === value) {
          this.setState((prevState) => ({
            ...prevState,
            education: {
              ...prevState.education,
              university_id: opt.key,
              university: opt.value,
              university_flag: true
            },
          }));
        }
        return null;
      });
    } else if (name === "discipline") {
      if (value === "") {
        this.setState((prevState) => ({
          ...prevState,
          education: {
            ...prevState.education,
            discipline_flag: false,
          },
        }));
      }
      this.props.disciplineOptions.map((opt) => {
        if (opt.value === value) {
          this.setState((prevState) => ({
            ...prevState,
            education: {
              ...prevState.education,
              discipline_id: opt.key,
              discipline: opt.value,
              discipline_flag: true,
            },
          }));
        }
        return null;
      });
    } else {
      this.setState((prevState) => ({
        ...prevState,
        education: {
          ...prevState.education,
          [name]: value,
        },
      }));
    }
  };

  handleChangeValueEducationDegree = (e, { name, value }) => {
    this.props.degreeOptions.map((opt) => {
      if (opt.value === value) {
        this.setState((prevState) => ({
          ...prevState,
          education: {
            ...prevState.education,
            degree_id: opt.key,
            degree: opt.value,
          },
          degreeSelected: true,
        }));
        this.props.getDiscipline(
          this.props.language,
          opt.key
        );
        this.props.getUniversity(
          this.props.language,
          opt.key
        );
      }
      return null;
    });
  };

  handleChangeValueCertification = (e, { name, value }) => {
    this.props.certificationsOptions.map((cert) => {
      if (name === "type_of_certification") {
        if (value === "") {
          this.setState((prevState) => ({
            ...prevState,
            certification_flag: false
          }));
        }
        if (cert.value === value) {
          this.setState((prevState) => ({
            ...prevState,
            certificationId: cert.key,
            certification_flag: true,
          }))
        }
      }
      return null;
    });

    this.setState((prevState) => ({
      ...prevState,
      certification: {
        ...prevState.certification,
        [name]: value,
      },
    }));
  };

  handleChangeLevelLanguage = (e, { name, value }) => {
    this.setState((prevState) => ({
      ...prevState,
      levelLanguage: {
        ...prevState.levelLanguage,
        [name]: value,
      },
    }));
  };

  handleRateLevelLanguage = (e, { rating, maxRating }) => {
    this.setState((prevState) => ({
      ...prevState,
      levelLanguage: {
        ...prevState.levelLanguage,
        level: rating,
      },
      checkValue: true,
    }));
  };

  handleChangeLevelSoftSkill = (e, { name, value }) => {
    this.setState((prevState) => ({
      ...prevState,
      levelSoftSkill: {
        ...prevState.levelSoftSkill,
        [name]: value,
      },
      checkValue: true,
    }));
  };

  handleRateLevelSoftSkill = (e, { rating, maxRating }) => {
    this.setState((prevState) => ({
      ...prevState,
      levelSoftSkill: {
        ...prevState.levelSoftSkill,
        level: rating,
      },
      checkValue: true,
    }));
  };

  handleChangeLevelTechnicalSkill = (e, { name, value }) => {
    this.setState((prevState) => ({
      ...prevState,
      levelTechnicalSkill: {
        ...prevState.levelTechnicalSkill,
        [name]: value,
      },
      checkValue: true,
    }));
  };

  handleRateLevelTechnicalSkill = (e, { rating, maxRating }) => {
    this.setState((prevState) => ({
      ...prevState,
      levelTechnicalSkill: {
        ...prevState.levelTechnicalSkill,
        level: rating,
      },
      checkValue: true,
    }));
  };

  onDatesChangeWorkExperience = ({ startDate, endDate }) => {
    this.setState((prevState) => ({
      ...prevState,
      workExperience: {
        ...prevState.workExperience,
        start: moment(startDate).set("date", 1),
        end: moment(endDate).set(
          "date",
          moment(endDate, "YYYY-MM-DD").daysInMonth()
        ),
      },
    }));
  };

  onDatesChangeEducation = ({ startDate, endDate }) => {
    this.setState((prevState) => ({
      ...prevState,
      education: {
        ...prevState.education,
        start: moment(startDate).set("date", 1),
        end: moment(endDate).set(
          "date",
          moment(endDate, "YYYY-MM-DD").daysInMonth()
        ),
      },
    }));
  };

  onDatesChangeCertification = ({ startDate, endDate }) => {
    this.setState((prevState) => ({
      ...prevState,
      certification: {
        ...prevState.certification,
        start: moment(startDate).set("date", 1),
        end: moment(endDate).set(
          "date",
          moment(endDate, "YYYY-MM-DD").daysInMonth()
        ),
      },
    }));
  };

  toggleCurrentRole = () => {
    this.setState((prevState) => ({
      ...prevState,
      workExperience: {
        ...prevState.workExperience,
        is_active: 1 - prevState.workExperience.is_active,
      },
    }));
  };

  toggleVisible = () => {
    this.setState((prevState) => ({
      ...prevState,
      workExperience: {
        ...prevState.workExperience,
        visible_on_cv: 1 - prevState.workExperience.visible_on_cv,
      },
    }));
  }

  toggleFlagSysAdmin = () => {
    this.setState((prevState) => ({
      ...prevState,
      is_sysadmin: 1 - prevState.is_sysadmin,
    }));
  };

  saveWorkExperience = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error editing. Try Again";
      else description = "You cannot perform this action.";

      toast({
        title: "Work Experience",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "Work Experience",
        description: "Edited successfully.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    if (this.state.workExperience.description !== null && this.state.workExperience.description.length > 1024) {
      this.openControlModalWorkExperience()
    } else {
      if (this.state.workExperience.is_active === 1) {
        this.setState((prevState) => ({
          ...prevState,
          workExperience: {
            ...prevState.workExperience,
            end: moment(),
            endMonth: moment().format("MMMM"),
            endYear: moment().year()
          }
        }));
      }

      this.props.editUserWorkExperience(
        this.state.workExperienceKey,
        this.props.language,
        this.state.workExperience,
        this.props.auth.unique_id,
        onSuccess,
        onFailure
      );

      this.closeWorkModal();
    }
  };

  saveEducation = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error editing. Try Again";
      else description = "You cannot perform this action.";

      toast({
        title: "Education",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "Education",
        description: "Edited successfully.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    this.props.editUserEducation(
      this.state.educationId,
      this.state.education,
      this.props.auth.unique_id,
      this.props.language,
      onSuccess,
      onFailure
    );

    this.closeEducationModal();
  };

  saveCertification = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error editing. Try Again";
      else description = "You cannot perform this action.";

      toast({
        title: "Certification",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "Certification",
        description: "Edited successfully.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    this.props.editUserCertification(
      this.state.certificationId,
      this.props.userRegistryRaw[0].curriculum_vitae_id,
      this.state.certification,
      this.props.auth.unique_id,
      this.props.language,
      onSuccess,
      onFailure
    );

    this.closeCertificationModal();
  };

  saveLevelTechnicalSkill = () => {
    if (
      this.state.levelTechnicalSkill.level < minLevel ||
      this.state.levelTechnicalSkill.level > maxLevel
    ) {
      this.closeLevelTechnicalSkillModal();

      toast({
        title: "Technical skill level - Error",
        description: "Value must be a number between 1 and 5",
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    } else {
      const onFailure = (res) => {
        let description = "";

        if (res.response && res.response.status === 406)
          description = res.response.data.error;
        else if (res.response) description = "Error editing. Try Again";
        else description = "You cannot perform this action.";

        toast({
          title: "Technical Skill",
          description: description,
          type: "error",
          icon: "file",
          time: constants.TOAST_ERROR_TIMEOUT,
          animation: "fly left",
        });
      };

      const onSuccess = (res) => {
        toast({
          title: "Technical Skill",
          description: "Edited successfully.",
          type: "success",
          icon: "check",
          time: constants.TOAST_SUCCESS_TIMEOUT,
          animation: "fly left",
        });
      };

      this.props.editUserTechnicalSkill(
        this.state.technicalSkillId,
        this.props.userRegistryRaw[0].curriculum_vitae_id,
        this.state.levelTechnicalSkill,
        this.props.auth.unique_id,
        this.props.language,
        onSuccess,
        onFailure
      );

      this.closeLevelTechnicalSkillModal();
    }
  };

  saveLevelSoftSkill = () => {
    if (
      this.state.levelSoftSkill.level < minLevel ||
      this.state.levelSoftSkill.level > maxLevel
    ) {
      this.closeLevelSoftSkillModal();

      toast({
        title: "Soft Skill Level - Error",
        description: "Value must be a number between 1 and 5",
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    } else {
      const onFailure = (res) => {
        let description = "";

        if (res.response && res.response.status === 406)
          description = res.response.data.error;
        else if (res.response) description = "Error editing. Try Again";
        else description = "You cannot perform this action.";

        toast({
          title: "Soft Skill",
          description: description,
          type: "error",
          icon: "file",
          time: constants.TOAST_ERROR_TIMEOUT,
          animation: "fly left",
        });
      };

      const onSuccess = (res) => {
        toast({
          title: "Soft Skill",
          description: "Edited successfully.",
          type: "success",
          icon: "check",
          time: constants.TOAST_SUCCESS_TIMEOUT,
          animation: "fly left",
        });
      };

      this.props.editUserSoftSkill(
        this.state.softSkillId,
        this.props.userRegistryRaw[0].curriculum_vitae_id,
        this.state.levelSoftSkill,
        this.props.auth.unique_id,
        this.props.language,
        onSuccess,
        onFailure
      );

      this.closeLevelSoftSkillModal();
    }
  };
  saveLevelLanguage = () => {
    if (
      this.state.levelLanguage.level < minLevel ||
      this.state.levelLanguage.level > maxLevel
    ) {
      this.closeLevelLanguageModal();

      toast({
        title: "Language Level - Error",
        description: "Value must be a number between 1 and 5",
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    } else {
      const onFailure = (res) => {
        let description = "";

        if (res.response && res.response.status === 406)
          description = res.response.data.error;
        else if (res.response) description = "Error editing. Try Again";
        else description = "You cannot perform this action.";

        toast({
          title: "Language",
          description: description,
          type: "error",
          icon: "file",
          time: constants.TOAST_ERROR_TIMEOUT,
          animation: "fly left",
        });
      };

      const onSuccess = (res) => {
        toast({
          title: "Language",
          description: "Edited successfully.",
          type: "success",
          icon: "check",
          time: constants.TOAST_SUCCESS_TIMEOUT,
          animation: "fly left",
        });
      };

      this.props.editUserLanguage(
        this.state.languageId,
        this.props.userRegistryRaw[0].curriculum_vitae_id,
        this.state.levelLanguage,
        this.props.auth.unique_id,
        this.props.language,
        onSuccess,
        onFailure
      );

      this.closeLevelLanguageModal();
    }
  };

  deleteWorkExperience = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error deleting. Try Again";
      else description = "You cannot perform this action.";

      toast({
        title: "Work Experience",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "Work Experience",
        description: "Deleted successfully.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    this.props.deleteUserWorkExperience(
      this.state.workExperienceKey,
      this.props.auth.unique_id,
      this.props.language,
      onSuccess,
      onFailure
    );

    this.closeWorkModal();
  };

  deleteEducation = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error deleting. Try Again";
      else description = "You cannot perform this action.";

      toast({
        title: "Education",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "Education",
        description: "Deleted successfully.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    this.props.deleteUserEducation(
      this.state.educationId,
      this.props.auth.unique_id,
      this.props.language,
      onSuccess,
      onFailure
    );

    this.closeEducationModal();
  };

  deleteCertification = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error deleting. Try Again";
      else description = "You cannot perform this action.";

      toast({
        title: "Certification",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "Certification",
        description: "Deleted successfully.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    this.props.deleteUserCertification(
      this.state.certificationId,
      this.props.userRegistryRaw[0].curriculum_vitae_id,
      this.props.auth.unique_id,
      this.props.language,
      onSuccess,
      onFailure
    );

    this.closeCertificationModal();
  };

  deleteUserLanguages = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error deleting. Try Again";
      else description = "You cannot perform this action.";

      toast({
        title: "Languages",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "Languages",
        description: "Deleted successfully.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    this.props.deleteUserLanguage(
      this.state.languageId,
      this.props.userRegistryRaw[0].curriculum_vitae_id,
      this.props.auth.unique_id,
      this.props.language,
      onSuccess,
      onFailure
    );

    this.closeLevelLanguageModal();
  };

  deleteUserSoftSkill = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error deleting. Try Again";
      else description = "You cannot perform this action.";

      toast({
        title: "Soft Skill",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "Soft Skill",
        description: "Deleted successfully.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    this.props.deleteUserSoftSkill(
      this.state.softSkillId,
      this.props.userRegistryRaw[0].curriculum_vitae_id,
      this.props.auth.unique_id,
      this.props.language,
      onSuccess,
      onFailure
    );

    this.closeLevelSoftSkillModal();
  };

  deleteUserTechnicalSkill = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error deleting. Try Again";
      else description = "You cannot perform this action.";

      toast({
        title: "Technical Skill",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "Technical Skill",
        description: "Deleted successfully.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    this.props.deleteUserTechnicalSkill(
      this.state.technicalSkillId,
      this.props.userRegistryRaw[0].curriculum_vitae_id,
      this.props.auth.unique_id,
      this.props.language,
      onSuccess,
      onFailure
    );

    this.closeLevelTechnicalSkillModal();
  };

  closeControlModalWorkExperience = () => {
    this.setState((prevState) => ({
      ...prevState,
      openControlModalWorkExperience: false,
    }))
  }

  openControlModalWorkExperience = () => {
    this.setState((prevState) => ({
      ...prevState,
      openControlModalWorkExperience: true,
    }))
  }

  addWorkExperience = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error adding. Try Again";
      else description = "You cannot perform this action.";

      toast({
        title: "Work Experience",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "Work Experience",
        description: "Added successfully.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    if (this.state.workExperience.description !== null && this.state.workExperience.description.length > 1024) {
      this.openControlModalWorkExperience()
    } else {
      this.props.createUserWorkExperience(
        this.props.userRegistryRaw[0].curriculum_vitae_id,
        this.props.language,
        this.state.workExperience,
        this.props.auth.unique_id,
        onSuccess,
        onFailure
      );

      this.closeWorkModal();
    }
  };

  addEducation = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error Adding. Try Again";
      else description = "You cannot perform this action.";

      toast({
        title: "Education",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "Education",
        description: "Added successfully.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    this.props.createUserEducation(
      this.state.educationId,
      this.props.userRegistryRaw[0].curriculum_vitae_id,
      this.state.education,
      this.props.auth.unique_id,
      this.props.language,
      onSuccess,
      onFailure
    );

    this.closeEducationModal();
  };

  addCertification = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error adding. Try Again";
      else description = "You cannot perform this action.";

      toast({
        title: "Certification",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "Certification",
        description: "Added successfully.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    this.props.createUserCertification(
      this.state.certificationId,
      this.props.userRegistryRaw[0].curriculum_vitae_id,
      this.state.certification,
      this.props.auth.unique_id,
      this.props.language,
      onSuccess,
      onFailure
    );

    this.closeCertificationModal();
  };
  selectCategory = (e, data) => {
    const name = data.value; // es: "categoria 1"

    data.options.map((opt) => {
      if (opt.value === name) {
        this.setState((prevState) => ({
          ...prevState,
          categoryId: opt.key,
          selectedCategory: true
        }))
        this.props.getTechnicalSkills(opt.key);
      }
      return null;
    });
  };

  addUserTechnicalSkill = () => {
    if (
      this.state.levelTechnicalSkill.level < minLevel ||
      this.state.levelTechnicalSkill.level > maxLevel
    ) {
      this.closeLevelTechnicalSkillModal();

      toast({
        title: "Technical skill level - Error",
        description: "Value must be a number between 1 and 5",
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    } else {
      const onFailure = (res) => {
        let description = "";

        if (res.response && res.response.status === 406)
          description = res.response.data.error;
        else if (res.response) description = "Error adding. Try Again";
        else description = "You cannot perform this action.";

        toast({
          title: "Technical Skill",
          description: description,
          type: "error",
          icon: "file",
          time: constants.TOAST_ERROR_TIMEOUT,
          animation: "fly left",
        });
      };

      const onSuccess = (res) => {
        toast({
          title: "Technical Skill",
          description: "Added successfully.",
          type: "success",
          icon: "check",
          time: constants.TOAST_SUCCESS_TIMEOUT,
          animation: "fly left",
        });
      };

      this.props.createUserTechnicalSkill(
        this.state.technicalSkillId,
        this.props.userRegistryRaw[0].curriculum_vitae_id,
        this.state.levelTechnicalSkill,
        this.props.auth.unique_id,
        this.props.language,
        onSuccess,
        onFailure
      );

      this.closeLevelTechnicalSkillModal();
    }
  };

  addUserSoftSkill = () => {
    if (
      this.state.levelSoftSkill.level < minLevel ||
      this.state.levelSoftSkill.level > maxLevel
    ) {
      this.closeLevelSoftSkillModal();

      toast({
        title: "Technical skill level - Error",
        description: "Value must be a number between 1 and 5",
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    } else {
      const onFailure = (res) => {
        let description = "";

        if (res.response && res.response.status === 406)
          description = res.response.data.error;
        else if (res.response) description = "Error adding. Try Again";
        else description = "You cannot perform this action.";

        toast({
          title: "Soft Skill",
          description: description,
          type: "error",
          icon: "file",
          time: constants.TOAST_ERROR_TIMEOUT,
          animation: "fly left",
        });
      };

      const onSuccess = (res) => {
        toast({
          title: "Soft Skill",
          description: "Added successfully.",
          type: "success",
          icon: "check",
          time: constants.TOAST_SUCCESS_TIMEOUT,
          animation: "fly left",
        });
      };

      this.props.createUserSoftSkill(
        this.state.softSkillId,
        this.props.userRegistryRaw[0].curriculum_vitae_id,
        this.state.levelSoftSkill,
        this.props.auth.unique_id,
        this.props.language,
        onSuccess,
        onFailure
      );

      this.closeLevelSoftSkillModal();
    }
  };

  addUserLanguage = () => {
    if (
      this.state.levelLanguage.level < minLevel ||
      this.state.levelLanguage.level > maxLevel
    ) {
      this.closeLevelLanguageModal();

      toast({
        title: "Technical skill level - Error",
        description: "Value must be a number between 1 and 5",
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    } else {
      const onFailure = (res) => {
        let description = "";

        if (res.response && res.response.status === 406)
          description = res.response.data.error;
        else if (res.response) description = "Error adding. Try Again";
        else description = "You cannot perform this action.";

        toast({
          title: "Language",
          description: description,
          type: "error",
          icon: "file",
          time: constants.TOAST_ERROR_TIMEOUT,
          animation: "fly left",
        });
      };

      const onSuccess = (res) => {
        toast({
          title: "Language",
          description: "Added successfully.",
          type: "success",
          icon: "check",
          time: constants.TOAST_SUCCESS_TIMEOUT,
          animation: "fly left",
        });
      };

      this.props.createUserLanguage(
        this.state.languageId,
        this.props.userRegistryRaw[0].curriculum_vitae_id,
        this.state.levelLanguage,
        this.props.auth.unique_id,
        this.props.language,
        onSuccess,
        onFailure
      );

      this.closeLevelLanguageModal();
    }
  };

  workInProgressMessage = () => {
    toast({
      title: "Work In progress",
      description: "Feature will be available soon!",
      type: "success",
      icon: "check",
      time: constants.TOAST_SUCCESS_TIMEOUT,
      animation: "fly left",
    });
  };

  onSelectRoleCV = (e, data) => {
    let role_id = 0;
    const name = data.value;

    data.options.map((opt) => {
      if (opt.value === name) {
        role_id = opt.key;
      }
      return null;
    });

    this.setState((prevState) => ({
      ...prevState,
      roleId: role_id,
      roleName: name,
    }));
  };

  saveRoleCV = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response) description = "Error editing. Try Again";
      else description = "You cannot perform this action.";

      toast({
        title: "Business Title",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "Business Title",
        description: "Edited successfully.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    this.props.editRoleCV(
      this.state.roleId,
      this.state.is_sysadmin,
      this.props.userRegistryRaw[0].curriculum_vitae_id,
      this.props.auth.unique_id,
      this.props.language,
      onSuccess,
      onFailure
    );

    this.setState((prevState) => ({
      ...prevState,
      roleName: this.props.userRegistryOption[0].business_title,
    }));

    this.closeModalRole();
  };

  downloadDocsCv = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response)
        description = "Error creating CV document. Try to logout/login and retry.";
      else description = "You cannot perform this action.";

      toast({
        title: "CV Docs",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "CV Docs",
        description: "Successfully created.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    this.props.createDocs(
      this.props.auth.unique_id,
      this.props.language,
      onSuccess,
      onFailure
    );
  };

  downloadDocsCvId = () => {
    const onFailure = (res) => {
      let description = "";

      if (res.response && res.response.status === 406)
        description = res.response.data.error;
      else if (res.response)
        description = "Error creating CV document. Try Again";
      else description = "You cannot perform this action.";

      toast({
        title: "CV Docs",
        description: description,
        type: "error",
        icon: "file",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    };

    const onSuccess = (res) => {
      toast({
        title: "CV Docs",
        description: "Successfully created.",
        type: "success",
        icon: "check",
        time: constants.TOAST_SUCCESS_TIMEOUT,
        animation: "fly left",
      });
    };

    this.props.createDocs(
      this.props.unique_id,
      this.props.language,
      onSuccess,
      onFailure
    );
  };

  diffSkill = (allSkill, userSkill) => {
    if (allSkill === undefined || allSkill.length === 0) {
      return []; // no skill founds, empty list
    }

    if (userSkill === undefined || userSkill.length === 0) {
      return allSkill; // no user skill found, return everything
    }

    let diff = allSkill;

    for (let as in allSkill) {
      for (let us in userSkill) {

        if ((allSkill[as] !== undefined && userSkill[us] !== undefined)
          && (
            (
              "value" in allSkill[as]
              && "value" in userSkill[us]
              && allSkill[as].value === userSkill[us].value
            )
            || (
              "value" in allSkill[as]
              && "type_of_certification" in userSkill[us]
              && allSkill[as].value === userSkill[us].type_of_certification
            )
          )
        ) {
          diff.splice(as, 1);
        }
      }
    }
    return diff;

  };

  render() {
    let indexRegistry = 0;

    return (
      <Container>
        <Table>
          <Table.Body>
            <Table.Row>
              <Table.Cell />

              {this.props.userRegistryOption &&
                this.props.userRegistryOption.length > 0
                ? this.props.userRegistryOption.map((value) => {
                  indexRegistry = indexRegistry + 1;



                  return (
                    <Segment
                      basic
                      className="cv-registry-section"
                    >
                      <ProjectForm
                        key={indexRegistry}
                        formFields={cv_registryFormData}
                        values={value ? value : {}}
                        loading={this.props.loadings}
                        handleChange={this.handleChange}
                        onSubmit={() => console.log("SUBMIT")}
                      />

                      <br />
                      {window.location.pathname === "/cvGenerator" ? (
                        <Button onClick={this.openModalRole}>
                          Change Business Title
                        </Button>
                      ) : null}
                    </Segment>
                  );
                })
                : null}
            </Table.Row>
          </Table.Body>
        </Table>

        <ExperienceTabPanel
          editable={window.location.pathname === "/cvGenerator"}
          userWorkExperienceOptions={this.props.userWorkExperienceOptions}
          userEducationOptions={this.props.userEducationOptions}
          userCertificationOptions={this.props.userCertificationOptions}
          onAddWork={this.openWorkModal}
          onAddEducation={this.openEducationModal}
          onAddCertification={this.openCertificationModal}
          onEditWork={this.handleEditWorkByIndex}
          onEditEducation={this.handleEditEducationByIndex}
          onEditCertification={this.handleEditCertificationByIndex}
        />

        <SkillsTabPanel
          editable={window.location.pathname === "/cvGenerator"}
          loading={this.props.loading}
          categoriesOptions={this.props.categoriesOptions}
          technicalSkillsOptions={this.props.technicalSkillsOptions}
          softSkillsOptions={this.props.softSkillsOptions}
          languagesOptions={this.props.languagesOptions}
          userTechnicalSkillsRaw={this.props.userTechnicalSkillsRaw}
          userSoftSkillsRaw={this.props.userSoftSkillsRaw}
          userLanguagesRaw={this.props.userLanguagesRaw}
          userTechnicalSkillsOptions={this.props.userTechnicalSkillsOptions}
          userSoftSkillsOptions={this.props.userSoftSkillsOptions}
          userLanguagesOptions={this.props.userLanguagesOptions}
          getTechnicalSkills={this.props.getTechnicalSkills}
          onAddTechnicalSkill={this.handleAddTechnicalSkill}
          onEditTechnicalSkill={this.handleEditTechnicalSkill}
          onDeleteTechnicalSkill={this.handleDeleteTechnicalSkill}
          onAddSoftSkill={this.handleAddSoftSkill}
          onEditSoftSkill={this.handleEditSoftSkill}
          onDeleteSoftSkill={this.handleDeleteSoftSkill}
          onAddLanguage={this.handleAddLanguage}
          onEditLanguage={this.handleEditLanguage}
          onDeleteLanguage={this.handleDeleteLanguage}
        />

        {window.location.pathname === "/cvGenerator" ? (
          <Grid>
            <Grid.Column>
              <div
                style={{
                  marginTop: "10px",
                  marginBottom: "20px",
                  marginRight: "20px",
                }}
              >
                <Button onClick={this.downloadDocsCv}>Download CV</Button>
              </div>
            </Grid.Column>
          </Grid>
        ) : (
          <Grid>
            <Grid.Column>
              <div
                style={{
                  marginTop: "10px",
                  marginBottom: "20px",
                  marginRight: "20px",
                }}
              >
                <Button onClick={this.downloadDocsCvId}>Download CV</Button>
              </div>
            </Grid.Column>
          </Grid>
        )}

        <Modal
          dimmer="blurring"
          open={this.state.openWorkModal}
          onClose={this.closeWorkModal}
          size="medium"
          closeIcon
        >
          <Modal.Header>Work Experience</Modal.Header>
          <Modal.Content scrolling>
            <Form style={{ clear: "both" }}>
              <Form.Field>
                <label>Sector</label>
                <Dropdown
                  placeholder="Select a sector"
                  search
                  clearable
                  selection
                  multiple={false}
                  onChange={this.handleChangeValueWorkExperience}
                  options={this.props.sectorOptions}
                  defaultValue={this.state.workExperience.sector}
                  name="sector"
                />
              </Form.Field>
              <Form.Field>
                <label>Business Title</label>
                <Dropdown
                  placeholder="Select a business title"
                  search
                  clearable
                  selection
                  multiple={false}
                  onChange={this.handleChangeValueWorkExperience}
                  options={this.props.roleOptions}
                  defaultValue={this.state.workExperience.role}
                  name="role"
                />
              </Form.Field>

              <Form.Field>
                <label>Customer</label>
                <Dropdown
                  placeholder="Select a customer"
                  search
                  clearable
                  selection
                  multiple={false}
                  required={true}
                  onChange={this.handleChangeValueWorkExperience}
                  options={this.props.customerOptions}
                  defaultValue={this.state.workExperience.customer}
                  name="customer"
                />
              </Form.Field>
              <Form.Input
                name="project_title"
                label="Project Title"
                type="text"
                onChange={this.handleChangeValueWorkExperience}
                value={this.state.workExperience.project_title}
              />

              <Form.Group widths="equal">
                <Form.TextArea
                  name="description"
                  label={<label>Description (max 1024 characters) ({(this.state.workExperience.description != null) ? this.state.workExperience.description.length : '0'})</label>}
                  type="text"
                  min={0}
                  max={1024}
                  onInput={this.handleChangeValueWorkExperience}
                  value={this.state.workExperience.description}
                />
              </Form.Group>
              <Form.Group inline>
                <Form.Field>
                  <label>From</label>
                  <Dropdown
                    search
                    selection
                    multiple={false}
                    name="startMonth"
                    onChange={this.handleChangeValueWorkExperience}
                    options={monthStr}
                    defaultValue={this.state.workExperience.startMonth} //start: "2009-01-01"
                  />
                </Form.Field>
                <Form.Field>
                  <Form.Input
                    name="startYear"
                    type="number"
                    min={1900}
                    onChange={this.handleChangeValueWorkExperience}
                    defaultValue={this.state.workExperience.startYear}
                  />
                </Form.Field>
              </Form.Group>

              {this.state.workExperience.is_active === 0 ? (
                <Form.Group inline>
                  <Form.Field>
                    <label>To &nbsp; &nbsp; &nbsp; </label>

                    <Dropdown
                      search
                      selection
                      multiple={false}
                      name="endMonth"
                      onChange={this.handleChangeValueWorkExperience}
                      options={monthStr}
                      defaultValue={this.state.workExperience.endMonth}
                    />
                  </Form.Field>
                  <Form.Field>
                    <Form.Input
                      name="endYear"
                      type="number"
                      min={1900}
                      onChange={this.handleChangeValueWorkExperience}
                      defaultValue={this.state.workExperience.endYear}
                    />
                  </Form.Field>
                </Form.Group>
              ) : null}

              <Checkbox
                label="Currently play this business title"
                onChange={this.toggleCurrentRole}
                checked={
                  this.state.workExperience.is_active === 1 ? true : false
                }
              />

              <br />
              <br />

              <Checkbox
                label="Visible on docs"
                onChange={this.toggleVisible}
                checked={
                  this.state.workExperience.visible_on_cv === 1 ? true : false
                }
              />
              <div style={{ marginTop: "1rem" }} />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            {this.state.editable ? (
              <Button onClick={this.saveWorkExperience} disabled={!this.state.workExperience.customer_flag || !this.state.workExperience.role_flag || !this.state.workExperience.sector_flag || !this.state.workExperience.title_flag || !this.state.workExperience.description_flag}>Save</Button>
            ) : (
              <Button onClick={this.addWorkExperience} disabled={!this.state.workExperience.customer_flag || !this.state.workExperience.role_flag || !this.state.workExperience.sector_flag || !this.state.workExperience.title_flag || !this.state.workExperience.description_flag}>Add</Button>
            )}

            {this.state.editable && (
              <Button color="red" onClick={this.deleteWorkExperience}>
                Delete
              </Button>
            )}
          </Modal.Actions>
        </Modal>

        <Modal
          dimmer="blurring"
          open={this.state.openEducationModal}
          onClose={this.closeEducationModal}
          size="small"
          closeIcon
        >
          <Modal.Header>Education</Modal.Header>
          <Modal.Content scrolling>
            <Form style={{ clear: "both" }}>
              <Form.Field>
                <label>Degree/MBA/Phd/High school</label>
                <Dropdown
                  name="degree"
                  placeholder="Select a degree/MBA/phd/high school"
                  onChange={this.handleChangeValueEducationDegree}
                  options={this.props.degreeOptions}
                  search
                  selection
                  multiple={false}
                  defaultValue={this.state.education.degree}
                />
              </Form.Field>
              {this.state.degreeSelected ? (
                <div>
                  <Form.Field>
                    <label>University/High school</label>
                    <Dropdown
                      name="university"
                      placeholder="Select a university/high school"
                      onChange={this.handleChangeValueEducation}
                      options={this.props.universityOptions}
                      search
                      clearable
                      selection
                      multiple={false}
                      defaultValue={this.state.education.university}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>Discipline</label>
                    <Dropdown
                      search
                      clearable
                      selection
                      multiple={false}
                      name="discipline"
                      placeholder="Select a discipline"
                      onChange={this.handleChangeValueEducation}
                      options={this.props.disciplineOptions}
                      defaultValue={this.state.education.discipline}
                    />
                  </Form.Field>
                </div>
              ) : (
                <div>
                  <Form.Field disabled>
                    <label>University/High school</label>
                    <Dropdown
                      name="university"
                      placeholder="Select a university/high school"
                      onChange={this.handleChangeValueEducation}
                      options={this.props.universityOptions}
                      search
                      clearable
                      selection
                      multiple={false}
                      defaultValue={this.state.education.university}
                    />
                  </Form.Field>
                  <Form.Field disabled>
                    <label>Discipline</label>
                    <Dropdown
                      search
                      clearable
                      selection
                      multiple={false}
                      name="discipline"
                      placeholder="Select a discipline"
                      onChange={this.handleChangeValueEducation}
                      options={this.props.disciplineOptions}
                      defaultValue={this.state.education.discipline}
                    />
                  </Form.Field>
                </div>
              )}

              <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                <Form.Field>
                  <Form.Input
                    name="vote"
                    label="Vote"
                    type="text"
                    placeholder="Please, use this format: your score/maximum score (e.g. 100/110 or 1/5 or A/E)"
                    onChange={this.handleChangeValueEducation}
                    value={this.state.education.vote}
                  />
                </Form.Field>
              </div>

              <Form.Group inline>
                <Form.Field>
                  <label>From</label>
                  <Dropdown
                    search
                    selection
                    multiple={false}
                    name="startMonth"
                    onChange={this.handleChangeValueEducation}
                    options={monthStr}
                    defaultValue={this.state.education.startMonth}
                  />
                </Form.Field>
                <Form.Field>
                  <Form.Input
                    name="startYear"
                    type="number"
                    min={1900}
                    onChange={this.handleChangeValueEducation}
                    defaultValue={this.state.education.startYear}
                  />
                </Form.Field>
              </Form.Group>

              <Form.Group inline>
                <Form.Field>
                  <label>To &nbsp; &nbsp; &nbsp; </label>

                  <Dropdown
                    search
                    selection
                    multiple={false}
                    name="endMonth"
                    onChange={this.handleChangeValueEducation}
                    options={monthStr}
                    defaultValue={this.state.education.endMonth}
                  />
                </Form.Field>
                <Form.Field>
                  <Form.Input
                    name="endYear"
                    type="number"
                    min={1900}
                    onChange={this.handleChangeValueEducation}
                    defaultValue={this.state.education.endYear}
                  />
                </Form.Field>
              </Form.Group>

              <div style={{ marginTop: "1rem" }} />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            {this.state.editable ? (
              <Button onClick={this.saveEducation} disabled={!this.state.education.university_flag || !this.state.education.discipline_flag}>Save</Button>
            ) : (
              <Button onClick={this.addEducation} disabled={!this.state.education.university_flag || !this.state.education.discipline_flag}>Add</Button>
            )}

            {this.state.editable && (
              <Button color="red" onClick={this.deleteEducation}>
                Delete
              </Button>
            )}
          </Modal.Actions>
        </Modal>

        <Modal
          dimmer="blurring"
          open={this.state.openCertificationModal}
          onClose={this.closeCertificationModal}
          size="small"
          closeIcon
        >
          <Modal.Header>Certification</Modal.Header>
          <Modal.Content scrolling>
            <Form style={{ clear: "both" }}>
              {!this.state.editable && (
                <Form.Field>
                  <label>Type of certification</label>
                  <Dropdown
                    search
                    clearable
                    selection
                    multiple={false}
                    name="type_of_certification"
                    placeholder="Select a certification"
                    onChange={this.handleChangeValueCertification}

                    options={this.diffSkill(
                      this.props.certificationsOptions,
                      this.props.userCertificationOptions
                    )}
                  />
                </Form.Field>
              )
              }

              <Form.Group inline>
                <Form.Field>
                  <label>Date</label>
                  <Dropdown
                    search
                    selection
                    multiple={false}
                    name="startMonth"
                    onChange={this.handleChangeValueCertification}
                    options={monthStr}
                    defaultValue={this.state.certification.startMonth}
                  />
                </Form.Field>
                <Form.Field>
                  <Form.Input
                    name="startYear"
                    type="number"
                    min={1900}
                    onChange={this.handleChangeValueCertification}
                    defaultValue={this.state.certification.startYear}
                  />
                </Form.Field>
              </Form.Group>

              <div style={{ marginTop: "1rem" }} />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            {this.state.editable ? (
              <Button onClick={this.saveCertification} disabled={!this.state.certification_flag}>Save</Button>
            ) : (
              <Button onClick={this.addCertification} disabled={!this.state.certification_flag}>Add</Button>
            )}
            {this.state.editable && (
              <Button color="red" onClick={this.deleteCertification}>
                Delete
              </Button>
            )}
          </Modal.Actions>
        </Modal>

        <Modal
          dimmer="blurring"
          open={this.state.openModalRole}
          onClose={this.closeModalRole}
          size="mini"
          closeIcon
        >
          <Modal.Header>Change Business Title</Modal.Header>

          <Modal.Content scrolling>
            <div
              style={{
                marginBottom: "4rem",
                marginLeft: "5rem",
                marginRight: "4rem",
                marginTop: "1rem",
              }}
            >
              <Form>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label>Business Title</label>

                    <Dropdown
                      placeholder="Select a business title"
                      search
                      clearable
                      selection
                      multiple={false}
                      onChange={this.onSelectRoleCV}
                      options={this.props.roleOptions}
                      value={this.state.roleName}
                      name="role"
                    />
                    <Checkbox
                      label="I'm System Administrator"
                      onChange={this.toggleFlagSysAdmin}
                      checked={this.state.is_sysadmin === 1 ? true : false}
                    />
                  </Form.Field>
                </Form.Group>
              </Form>
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.saveRoleCV}>Save</Button>
          </Modal.Actions>
        </Modal>
        <Modal
          open={this.state.openControlModalWorkExperience}
        >
          <Modal.Header>Attention</Modal.Header>
          <Modal.Content image>
            <p>Description greater than 1024 characters</p>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.closeControlModalWorkExperience}>Close</Button>
          </Modal.Actions>
        </Modal>
      </Container>
    );
  }
}

export default CvGeneratorComponent;
